module.exports = __webpack_public_path__ + "img/114.rocedure_for_making_an_appointment.05f02863.svg";